import React, { useContext, useState } from "react";
import { Form } from "antd";
import { ModalForm } from "src/enitities/Modal";
import { PriceForm, serializeTimestamp } from "src/enitities/Form";
import { PricesContext } from "src/shared";
import { API } from "src/shared";

export default function AddCategory({ isOpen, setOpen }) {
  const [changeData, setChangeData] = useState(false);
  const { token, pathname } = useContext(PricesContext);
  const [form] = Form.useForm();

  const handleSubmit = async (data) => {
    console.log(data);
    const queryCreate = API.crud.create(token, pathname);
    const newData = serializeTimestamp(data[0], ["date_from", "date_to"]);
    try {
      await queryCreate([newData]);
      return true;
    } catch (err) {
      return Promise.reject(err.message.detail);
    }
  };

  return (
    <ModalForm
      title={"Добавить категорию"}
      width={500}
      isOpen={isOpen}
      setOpen={setOpen}
      formContext={form}
      handleSubmit={handleSubmit}
      changeData={changeData}
      setChangeData={setChangeData}>
      <PriceForm formContext={form} disableNomeclature={false} />
    </ModalForm>
  );
}
